module.exports = __webpack_public_path__ + "static/img/sec4-desc@t.ffd6f88.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-life-science/sec4-desc@t.png
// module id = WfEU
// module chunks = 0